import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { type CargoTypeFiltersUpdateApi, cargoTypesApiSchema } from '../../models';

const masterDataApi = fetcher.extend(() => ({ prefixUrl: `${API.MASTER_DATA_PUBLIC}` }));

export const fetchCargoTypes = async (
  filters: CargoTypeFiltersUpdateApi,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await masterDataApi.get('lookup-code/CARGO', { searchParams: filters, signal }).json(cargoTypesApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn('Validation error on cargo types response', (error as ValiError<typeof cargoTypesApiSchema>).issues);
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
